module.exports = __webpack_public_path__ + "08592c649f3e2120eb44018955b68079.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg48.jpeg
// module id = 59
// module chunks = 0